import * as React from "react";
import { GetCurrentGamePrefix } from "common/constants/Games";
import { useForceUpdate } from "common/helpers/componentHelper";
import { changeUrl } from "common/history";
import PicksHelper from "common/picksHelper";
import Store from "common/store";
import StoreKeys from "common/storeKeys";

export function useOtherLiveEvent(eventData, live) {
	const forceUpdate = useForceUpdate();
	const both = !!live?.main && !!live?.secondary;
	const onMain = both && eventData?.id === live.main.id;
	const onSecondary = both && eventData?.id === live.secondary.id;
	const other = onMain ? live.secondary : live.main;
	const picksHelper = new PicksHelper(other);

	React.useEffect(() => {
		if (!onMain) {
			return;
		}

		const timer = window.setTimeout(forceUpdate, 1000);
		return () => window.clearTimeout(timer);
	});

	if (
		!(onMain || onSecondary) ||
		(onMain && picksHelper.isLocked()) ||
		(onSecondary && picksHelper.isFinished())
	) {
		return null;
	}

	return { other, onMain, picksHelper };
}

export function openLiveEvent(other) {
	changeUrl(`${GetCurrentGamePrefix()}/event/${other.id}`);

	Store.cacheChanges("LiveEventHero");
	Store.set(StoreKeys.LeftPane.PastEventIndex, 0);
	Store.set(StoreKeys.LeftPane.ViewingPastEvents, false);
	Store.applyChanges("LiveEventHero");
}
